import styled from 'styled-components';
import { fontBody, fontAccent } from 'Styles/fonts';
import { black } from 'Styles/colors';
import breakpoint from 'Styles/breakpoints';
import ShopButtonsOriginal from '../ShopButtons/ShopButtons';

export const FormSubmissionSuccess = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;

export const Title = styled.h1`
  ${fontAccent(24)};
  color: ${black};
  margin-top: 8px;
  margin-bottom: -8px;

  ${breakpoint('medium', { mode: 'container' })} {
    ${fontAccent(32)}
  }

  ${breakpoint('large', { mode: 'container' })} {
    ${fontAccent(40)}
  }
`;

export const Message = styled.div`
  ${fontBody(16)};
  color: ${black};
  margin: 16px 0;
  padding: 0;

  ${breakpoint('medium', { mode: 'container' })} {
    ${fontBody(18)}
  }

  ${breakpoint('large', { mode: 'container' })} {
    ${fontBody(24)}
  }
`;

export const ShopButtons = styled(ShopButtonsOriginal)`
  row-gap: 12px;
`;

export default {};
